<template>
  <multiselect
    id="ajax"
    v-model="selectedPositions"
    label="name"
    track-by="name"
    placeholder="Type to search for job title"
    open-direction="bottom"
    :options="positions"
    :multiple="true"
    :loading="isLoading"
    :clear-on-select="false"
    :close-on-select="false"
    :searchable="true"
    :internal-search="false"
    :show-no-results="false"
    :hide-selected="true"
    :taggable="true"
    tag-placeholder="Enter to search for this job title"
    :max-height="600"
    @tag="addTag"
    @search-change="searchPosition"
    @input="inputOption"
    @remove="removeOption"
  >
    <span
      slot="afterList"
      v-observe-visibility="visibilityChanged"
    >
      <!-- This will be shown when there are no results -->
      <hr/>
    </span>
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";
import { ObserveVisibility } from "vue-observe-visibility";

export default {
    name: "JobTitleSelect",
    components: { Multiselect },
    directives: {
        ObserveVisibility,
    },
    data() {
        return {
            positionTags: [],
            positionFilters: [],
            searchUrl: "/admin/expert/api-get-positions",
            selectedPositions: [],
            positions: [],
            isLoading: false,
            page: 1,
            searchQuery: null,
        };
    },
    watch: {
        positionTags(value) {
            const tagStrings = value.join(" ");
            this.$emit("input", tagStrings);
        },
        positionFilters(filters) {
            this.$emit("update-filter", filters);
        },
    },
    methods: {
        getSelectedTags() {
            return this.positionTags
        },
        addTag(newTag) {
            const selectedPositions = this.selectedPositions;

            const inTags = selectedPositions.some(tag => {
                return newTag === tag.name;
            });

            if (!inTags && newTag.length >= 2) {
                const tag = {
                    name: newTag,
                    id: "tag_" + newTag.substring(0, 2) + Math.floor((Math.random() * 10000000)),
                    type: "tag",
                };
                this.positionTags.push(newTag);

                this.selectedPositions.push(tag);
                this.positions.push(tag);
            }
        },
        inputOption(options, id) {
            this.positionFilters = options.filter(option => {
                return option.type === undefined;
            }).map(option => option.name);
        },
        removeOption(removedOption, id) {
            const isTag = removedOption.type === "tag";
            const optionTag = removedOption.name;
            const tags = this.positionTags;

            if (isTag) {
                this.positionTags = tags.filter(tag => tag !== optionTag);
            }
        },
        searchPositionDebounce(searchQuery) {
            // Cancel the previous request
            if (this.source) {
                this.source.cancel("Operation canceled due to new request.");
            }

            // Create a new CancelToken
            this.source = axios.CancelToken.source();
            this.isLoading = true;

            let page = this.page

            axios.get(this.searchUrl, {
                cancelToken: this.source.token, // Pass the cancel token to the current request
                params: {
                    search: searchQuery,
                    pagination: 20,
                    page: page,
                },
            }).then(response => {
                this.positions = [...this.positions, ...response.data.data.map((job, i) => {
                    const id = i++;
                    return {
                        id: id,
                        name: job.position,
                    };
                })];

                this.isLoading = false;
            }).catch(error => {
                if (axios.isCancel(error)) {
                    console.log("Request canceled", error.message);
                } else {
                    console.log("Something went wrong: " + error.message);
                }
            });
        },
        searchPosition(searchQuery) {
            //reset params on search text change
            this.searchQuery = searchQuery;
            this.positions = [];
            this.page = 1

            if (searchQuery.length >= 2) {
                _.debounce(this.searchPositionDebounce, 500, { "maxWait": 1000 })(searchQuery);
            }

        },
        limitText(count) {
            return `and ${count} other companies`;
        },
        visibilityChanged(isVisible, entry) {
            if (isVisible) {
                this.loadMore();
            }
        },
        loadMore() {
            this.searchPositionDebounce(this.searchQuery);
            this.page += 1;
        },
    },
};
</script>

<style scoped>

</style>
